import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { loginUser } from "../../store/actions/authActions";
import {  Card,  Button, ButtonToolbar} from 'react-bootstrap';
import validate from './validateReset';

import { Input, FormFeedback, FormGroup, Label } from 'reactstrap';

class Signin extends Component {

 
  handleFormSubmit(data) {
    this.props.loginUser(data, this.onSigninComplete.bind(this));
    }

    onBackToLoginClicked = () => {
        this.props.history.push("/forgetpassword");
    }

 
 onSigninComplete() {  
   this.props.history.push("/");
 }
 
  render() {
    const { handleSubmit } = this.props
      return (
          <div className="login-style">
          <Card className="mx-auto">
            
              <Card.Header as="h5">Login</Card.Header>
              <Card.Body>
                
                  <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>

                      <div>
                          <div>
                              <Field
                                      name="Email"
                                      component={renderTextField}
                                      type="email"
                                      placeholder="Email"
                              />
                          </div>
                      </div>
                      <div>
                          <div>
                              <Field
                                  name="Password"
                                      component={renderTextField}
                                  type="password"
                                  placeholder="Password"
                              />
                          </div>
                      </div>
                      <div>
                          <span style={{ color: 'red' }}>
                              {this.props.auth.login_error}
                          </span>
                      </div>
                          <div>
                              <ButtonToolbar>
                                  <Button size="sm" type="submit">
                                      Signin
          </Button>

                                  <Button size="sm" type="button" onClick={this.onBackToLoginClicked}>
                                      Forgot Password
          </Button>
                              </ButtonToolbar>
                            
                      </div>
                  </form>
              </Card.Body>
          </Card>
    </div>
    )
  }
}

const renderTextField = ({ input, meta: { asyncValidating,touched, error, warning }, ...custom }) => (
    <Fragment>
        <FormGroup>
            <Label>{input.name}</Label>
            <Input {...(touched ? { valid: !error } : {})} {...(touched ? { invalid: error } : {})} {...input} {...custom} />
            {touched && error && <FormFeedback>{error}</FormFeedback>}      
        </FormGroup>       
       
      
    </Fragment>
);
 
Signin = reduxForm({
  form: 'Signin' // a unique identifier for this form
})(Signin);
 
function mapStateToProp(state) {
  return {
      auth: state.auth,      
      validate
  };
}
 
Signin = connect(mapStateToProp, { loginUser })(withRouter(Signin));
 
export default Signin;


// WEBPACK FOOTER //
// ./src/components/auth/Signin.js